import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface CustomRadioProps extends React.ReactElement {
  fieldKey: string;
  value: string;
  label: string;
  options: { label: string; value: string }[];
  onChange: (key: string, value: string) => void;
  disabled: boolean;
  required: boolean;
}

const CustomRadio: React.FC<CustomRadioProps> = ({
  fieldKey,
  value,
  label,
  options,
  onChange,
  disabled,
  required,
}) => {
  return (
    <FormControl disabled={disabled} required={required}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        value={value}
        onChange={(asd) => onChange(fieldKey, asd.target.value)}
        aria-label={label}
      >
        {options.map(({ label: optionLabel, value: optionValue }) => (
          <FormControlLabel
            key={optionValue}
            value={optionValue}
            control={<Radio required={required} />}
            label={optionLabel}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CustomRadio;
